import {
  ICommonDict,
  IErrorDict,
  IPasswordReqDict,
  IBreakoutDict,
  IThankYouDict,
  IRegistrationDict,
  ISurveyDict,
  IScenesDict
} from 'types'

const common: ICommonDict = {
  alreadyHaveAnAccount: 'Already registered?',
  back: 'Back',
  completeRegistration: 'Complete Registration',
  confirmationCode: 'Verification Code',
  confirmEmail: 'Email Verification.',
  confirmEmailInstructions:
    'A confirmation code was sent to your e-mail. Didn’t receive it? Check your spam folder or hit back and try again.',
  didntReceiveTheEmail: 'Didn’t receive the verification email? Check your spam folder or',
  resendVerificationEmailLower: 'resend verification email.',
  resendEmailVerification: 'Resend email verification',
  confirmPassword: 'Confirm Password',
  continue: 'Continue',
  dontHaveAnAccount: "Don't have an account?",
  email: 'E-mail',
  eventInfo: 'Event Info',
  firstName: 'First Name',
  forgotPassword: 'Forgot Password?',
  help: 'Help',
  lastName: 'Last Name',
  next: 'Next',
  password: 'Password',
  passwordRequirements: 'Password Requirements',
  register: 'Register',
  resendCode: 'Resend Code',
  select: 'Select',
  signIn: 'Replay',
  signUp: 'Sign Up',
  submit: 'Submit'
}

const survey: ISurveyDict = {
  surveyTitle: 'Quick Survey.',
  surveyInstructions: "We'd love to hear from you.",
  'question-keynoteSpeaker':
    'Do you have any questions for our key note speaker? Help us kick off the event with Bozoma Saint John.',
  'question-learningObjectives': 'What do you want to learn about 5G? What do you want to get out of this event?'
}

const registration: IRegistrationDict = {
  avatarInstructions: 'Upload picture for event profile',
  address: 'Address Line 1',
  addressLineTwo: 'Address Line 2',
  city: 'Post Town/City',
  state: 'County/Region/Province',
  zip: 'Postal Code',
  country: 'Country',
  jobTitle: 'Job title',
  company: 'Company',
  companyName: 'Company',
  companySize: 'Company Size',
  completeRegistration: `To get started, let's set up your personal profile.`,
  mailingAddress: 'Current mailing address',
  mailingAddressReason:
    'If you would like to receive a complimentary watch kit, please provide your address below. Please note, watch kits are subject to availability.',
  dropImage: 'Drop the image here...',
  employeeRange1: '0 - 9 Employees',
  employeeRange2: '10 - 499 Employees',
  employeeRange3: '500+ Employees',
  joinUs: 'View 5G Ready: Built Right for Business with Verizon',
  joinUsTime: '24 November 2020 • 2pm GMT/3pm CET',
  cSuite: 'C-Suite',
  vp: 'VP',
  director: 'Director',
  manager: 'Manager',
  staff: 'Staff',
  companyAddress: 'Organization address',
  phoneNumber: 'Phone Number',
  selectedImage: 'Selected image: ',

  aboutYourCompany: 'About your organization',
  youreIn: "Congrats, You're In!",
  emailWillBecomeUsername: 'Your email will automatically become your username.',
  commPreferenceTitle: 'Communications preference',
  commPreferenceLabel: 'Communication preference',
  commPreferenceBlurb:
    'Verizon may wish to contact you in the future concerning its products and/or services. If you would like to receive these communications from Verizon, indicate by selecting from the dropdown menu below. Please note that you can <a href="https://info.verizonenterprise.com/UnsubscribePage.html" target="_blank">unsubscribe</a> or update your <a href="https://enterprise.verizon.com/your-preferences/" target="_blank">preferences</a> at any time.',
  commPreferencesHere: 'here.',
  commPreferenceYes: 'Yes - I wish to receive communications about Verizon products/services.',
  commPreferenceNo: 'No - I do not wish to receive communications about Verizon products/services.',
  interestsTitle: 'Tell us about<br/>your interests',
  interestsBlurb:
    "Private 5G is applicable to many industries and locations. However, to help us deliver the most engaging event, we would like to know if you're particularly interested in content on any of the following? Please any/all that apply.",
  'interestName-5gInGermany': '5G in Germany (in German language)',
  'interestName-5gInFrance': '5G in France (in French language)',
  'interestName-manufacturing': 'Manufacturing',
  'interestName-healthcare': 'Healthcare',
  'interestName-venues': 'Venues',
  'interestName-transport': 'Transport',
  'interestName-5gInEmea': 'General 5G in EMEA',
  termsSetInPrivacyPolicy:
    'The information provided will be used in accordance with our terms set out in our <a href="https://www.verizon.com/about/privacy/" target="_blank">Privacy Policy</a>. Please confirm you have read and understood this Policy.',
  iConfirmPolicy: 'I confirm I have read and understood',
  endUserNote:
    '*Please note that this is an end user event, all applications to register from non end user organizations will be subject to availability.'
}

const breakout: IBreakoutDict = {
  registerForABreakout: 'Register for a breakout session.',
  reserveYourBreakoutBlurb:
    "Following the presentations, you'll have an opportunity to hear how your business can take advantage of the full, transformative power of 5G.  Let our experts take you on a deeper dive into vertical-specific use cases to demonstrate how your business can benefit from Verizon's 5G.<br/>Each session includes a live Q&A. Capacity is limited to 200 attendees each. Please make your selection to save your spot!",
  breakoutSession: 'Breakout session',
  'breakoutSessionName-healthcareInsurance': 'Healthcare, Insurance & Life Sciences',
  'breakoutSessionPresenter-healthcareInsurance': '',
  'breakoutSessionDescription-healthcareInsurance': '',
  'breakoutSessionName-retailTravelDistribution': 'Retail/Hospitality, Travel & Distribution',
  'breakoutSessionPresenter-retailTravelDistribution': '',
  'breakoutSessionDescription-retailTravelDistribution': '',
  'breakoutSessionName-financialServices': 'Financial Services',
  'breakoutSessionPresenter-financialServices': '',
  'breakoutSessionDescription-financialServices': '',
  'breakoutSessionName-manufacturingEnergyUtilities': 'Manufacturing, Automotive, Construction, Energy & Utilities',
  'breakoutSessionPresenter-manufacturingEnergyUtilities': '',
  'breakoutSessionDescription-manufacturingEnergyUtilities': '',
  'breakoutSessionName-mediaEntertainmentTech': 'Media, Entertainment, Technology & Services',
  'breakoutSessionPresenter-mediaEntertainmentTech': '',
  'breakoutSessionDescription-mediaEntertainmentTech': '',
  finish: 'Finish',
  skip: 'Skip'
}

const passwordRequirements: IPasswordReqDict = {
  passwordMustContain: 'Password must contain:',
  passwordReqLength: 'Must contain at least 12 characters',
  passwordReqUpperCase: 'Must contain at least one upper-case letter',
  passwordReqLowerCase: 'Must contain at least one lower-case letter',
  passwordReqNumber: 'Must contain at least one number',
  passwordReqSymbol: 'Must contain at least one special character'
}

const thankYou: IThankYouDict = {
  lookForwardToSeeingYou: 'We look forward to seeing you!',
  registrationCompleteBlurb:
    'Your registration is complete! We look forward to seeing you at 5G Ready: Built Right for Business for Verizon on 24 November 2020.',
  stayTuned: 'Please check your email for the registration confirmation and for updates as the event approaches.',
  eventInfo: 'Event Info',
  verizonHub: 'Verizon Hub'
}

const errors: IErrorDict = {
  emailAlreadyRegistered: 'This E-mail has already been registered.',
  emailNotFound: 'E-mail not found',
  incorrectEmailOrPassword: 'Incorrect E-mail or password.',
  invalidConfirmationCode: 'Invalid verification code.',
  invalidEmail: 'Invalid E-mail Address',
  invalidPassword: 'Password does not meet requirements',
  invalidPhone: 'Invalid Phone Number',
  invalidZip: 'Invalid Postal Code',
  invalidCity: 'Invalid City',
  limitExceeded: 'Attempt limit exceeded. Please try again later.',
  passwordsMustMatch: 'Passwords must match.',
  requiredField: 'Required Field',
  youMustConfirmToProceed: 'You must confirm to proceed.'
}

const scenes: IScenesDict = {
  exploreSceneTitle: 'Rethink what’s possible in a 5G world.',
  exploreSceneBlurb:
    'What can private 5G do for your business? Explore the various ways a private 5G network built right can move businesses like yours forward.',
  sessionsSceneTitle: 'View the series of vertical and country specific recorded breakout sessions.',
  sessionsSceneBlurb:
    'Each session includes a panel of experts from both Verizon and Nokia, answering end user questions on the breakout topic.',
  clickAndDragToExplore: 'Click and drag to explore',
  theEventWillBeginIn: 'The next session will begin in',
  theEventWillStartOn: 'The next session will start on',
  explore: 'Explore',
  sessions: 'Sessions',
  connect: 'Connect',
  liveStream: 'Live Stream',
  startingSoon: 'The Live Event is starting soon',
  goToLiveStream: 'Go to Live Stream',
  genericBreakoutsStartingMessage:
    "It's almost time to hear how your business can take advantage of the transformative power of Verizon private 5G. Let our experts take you on a deeper dive into vertical and country specific use cases to demonstrate how Verizon 5G can benefit you. Each session includes a live Q&A. Click below to see which sessions are available to join."
}

export const en = {
  ...common,
  ...passwordRequirements,
  ...errors,
  ...registration,
  ...breakout,
  ...survey,
  ...thankYou,
  ...scenes
}
